try {
    if (!customElements.get("collapsible-tab")) {
        class e extends HTMLElement {
            constructor() {
                super()
            }
            connectedCallback() {
                this.init()
            }
            disconnectedCallback() {
                this.destroy()
            }
            init() {
                "true" === this.dataset.destroy || (this.setDefaultData(),
                this.attachEvents(),
                "true" === this.getAttribute("open") ? (this.selected = !0,
                this.classList.add(this.expandedClass),
                this.setExpandedAria()) : (this.content.style.height = this.collapsedHeight,
                this.classList.add(this.collapsedClass),
                this.setCollapsedAria()),
                this.content.removeAttribute("hidden"))
            }
            transitionendEventName() {
                let e, t = document.createElement("div"), s = {
                    transition: "transitionend",
                    OTransition: "otransitionend",
                    MozTransition: "transitionend",
                    WebkitTransition: "webkitTransitionEnd"
                };
                for (e in s)
                    if (s.hasOwnProperty(e) && void 0 !== t.style[e])
                        return s[e]
            }
            expand() {
                const e = (t=>{
                    t.target === this.content && (this.content.removeEventListener(this.transitionendevent, e),
                    this.isOpen && requestAnimationFrame((()=>{
                        this.content.style.transition = "0",
                        this.content.style.height = "auto",
                        requestAnimationFrame((()=>{
                            this.content.style.height = null,
                            this.content.style.transition = null,
                            this.setExpandedAria(),
                            this.classList.add(this.expandedClass),
                            this.trySetTabIndex(this.content, 0),
                            this.fire("tabOpened")
                        }
                        ))
                    }
                    )))
                }
                ).bind(this);
                this.content.addEventListener(this.transitionendevent, e),
                this.isOpen = !0,
                this.classList.remove(this.collapsedClass),
                this.content.style.height = this.content.scrollHeight + "px"
            }
            collapse() {
                const e = (t=>{
                    t.target === this.content && (this.content.removeEventListener(this.transitionendevent, e),
                    this.isOpen || (this.fire("elementClosed"),
                    this.setCollapsedAria(),
                    this.classList.add(this.collapsedClass),
                    this.trySetTabIndex(this.content, -1)))
                }
                ).bind(this);
                this.content.addEventListener(this.transitionendevent, e),
                this.isOpen = !1,
                this.classList.remove(this.expandedClass),
                requestAnimationFrame((()=>{
                    this.content.style.transition = "0",
                    this.content.style.height = this.content.scrollHeight + "px",
                    requestAnimationFrame((()=>{
                        this.content.style.transition = null,
                        this.content.style.height = this.collapsedHeight
                    }
                    ))
                }
                ))
            }
            open() {
                this.selected = !0,
                this.fire("elementSelected"),
                this.expand(),
                this.setAttribute("open", !0)
            }
            close() {
                this.selected = !1,
                this.fire("elementUnselected"),
                this.collapse(),
                this.removeAttribute("open")
            }
            toggle(e) {
                if (e.preventDefault(),
                this.selected)
                    this.close();
                else if (this.open(),
                this.oneAtATime) {
                    const e = document.querySelectorAll("collapsible-tab")
                      , t = this.closest("[data-first-level]");
                    e.length && e.forEach((e=>{
                        e !== this && e.selected && t !== e && e.close()
                    }
                    ))
                }
            }
            trySetTabIndex(e, t) {
                const s = e.querySelectorAll(this.defaultElements);
                s && s.forEach((e=>{
                    e.setAttribute("tabindex", t)
                }
                ))
            }
            setExpandedAria() {
                this.trigger.setAttribute("aria-expanded", "true"),
                this.content.setAttribute("aria-hidden", "false")
            }
            setCollapsedAria(e) {
                this.trigger.setAttribute("aria-expanded", "false"),
                this.content.setAttribute("aria-hidden", "true")
            }
            attachEvents() {
                this.trigger.addEventListener("click", (e=>this.toggle(e)))
            }
            setDefaultData() {
                this.events = {
                    elementSelected: [],
                    tabOpened: [],
                    elementUnselected: [],
                    elementClosed: []
                },
                this.transitionendevent = this.transitionendEventName(),
                this.expandedClass = "is-expanded",
                this.collapsedClass = "is-collapsed",
                this.trigger = this.querySelector("[data-trigger]"),
                this.content = this.querySelector("[data-content]"),
                this.collapsedHeight = "0px",
                this.defaultElements = ["a", "button", "input:not(.focus-none)", "[data-trigger]"],
                this.oneAtATime = !0,
                this.dataset.oneOpen && (this.oneAtATime = "true" === this.dataset.oneOpen)
            }
            fire(e) {
                let t = this.events[e];
                if (t)
                    for (let e = 0; e < t.length; e++)
                        t[e](this)
            }
            on(e, t) {
                this.events[e] && this.events[e].push(t)
            }
            destroy() {
                this.trigger.removeEventListener("click", (e=>this.toggle(e))),
                this.content.removeAttribute("aria-hidden"),
                this.content.style.height = "auto",
                this.classList.remove(this.expandedClass, this.collapsedClass),
                this.removeAttribute("open")
            }
        }
        customElements.define("collapsible-tab", e)
    }
    jQuery_T4NT(document).ready(function(){
        $('[data-mobile-menu]').on('click', function(e){
            e.preventDefault();
            $('.mm-menu').addClass('mm-menu_opened');
            $('#shopify-chat').show();
        });
        $('.mm-close-btn').on('click', function(){
            $('.mm-menu').removeClass('mm-menu_opened');
            $('#shopify-chat').hide();
        });
        $('.mb-close').on('click', function(){
            $('.mm-menu').removeClass('mm-menu_opened');
            $('#shopify-chat').hide();
        });
        $('.ui-menu-item').on('click', function() {
            let self = $(this);
            $(self.data('parent-href'))
                .addClass('mm-panel_opened-parent mm-hidden')
                .removeClass('mm-panel_opened');
            $(self.data('child-href'))
                .addClass('mm-panel_opened')
                .removeClass('mm-panel_opened-parent mm-hidden');
        });
        $('.mm-btn_prev').on('click', function(){
            let self = $(this);
            $(self.data('parent-href'))
                .addClass('mm-panel_opened')
                .removeClass('mm-panel_opened-parent mm-hidden');
            $(self.data('current-href'))
                .addClass('mm-panel_opened-parent mm-hidden')
                .removeClass('mm-panel_opened');
        });
        function setSubMenuWidth() {
            if ($(window).innerWidth() >= 1025) {
                console.log('resize: ' + $('.bruce-header-container').width());
                setTimeout(() => {
                    $('.t4s-type__mega > .t4s-sub-menu').css('width', $('.bruce-header-container').width());    
                }, 1500);
                
                console.log($('.t4s-type__mega > .t4s-sub-menu').width())
            }
        }
        // setSubMenuWidth();
        $(window).resize(function() {
            // setSubMenuWidth();
        });
        function isElementInViewport(el) {
            var rect = el.getBoundingClientRect();
            // console.log(rect);
            // console.log('window.innerHeight: ' + window.innerHeight, 'document.documentElement.clientHeight:' + document.documentElement.clientHeight);
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
        jQuery_T4NT(window).scroll(function(){
            var tags = $(".fade-in-section");
            var currentScrollTop = $(this).scrollTop();
            for (let i = 0; i < tags.length; i++) {
              var tag = tags[i];
              if (isElementInViewport($(tag)[0])) {
                // console.log('in view');
                $(tag).addClass("is-visible");
              } else {
                if ($(tag).offset().top > currentScrollTop) {
                    $(tag).removeClass("is-visible");
                } else {
                    $(tag).addClass("is-visible");
                }
              }
            }
        });
        if (window.location.href.indexOf('en-eu') != -1 || 
            window.location.href.indexOf('de-de') != -1 || 
            window.location.href.indexOf('fr-fr') != -1 || 
            window.location.href.indexOf('en-gb') != -1) {
            setInterval(function(){
                console.log('check aca');
                if ($('#aca-bottom-close').length > 0) {
                    $('#aca-bottom-close').trigger('click');
                }
                if ($('.pg-progress-container').length > 0) {
                    $('.pg-progress-container').hide();
                }
            }, 1000);
        }
        jQuery_T4NT('.mb_blocks').hover(function(){
            jQuery_T4NT('.bruce-header-container').addClass('mb_blocks__hover');
            jQuery_T4NT('.header-cover').show();
        },function(){
            jQuery_T4NT('.bruce-header-container').removeClass('mb_blocks__hover');
            jQuery_T4NT('.header-cover').hide();
        });
        jQuery_T4NT('.t4s-menu-item').hover(function(){
            jQuery_T4NT('.header-cover').show();
        }, function() {
            jQuery_T4NT('.header-cover').hide();
        });
    });
    if (!customElements.get("scrolling-promotion")) {
        window.btheme = window.btheme || {};

        btheme.initWhenVisible = function(options) {
            const threshold = options.threshold ? options.threshold : 0;

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (typeof options.callback === 'function') {
                            options.callback();
                            observer.unobserve(entry.target);
                        }
                    }
                });
            }, {rootMargin: `0px 0px ${threshold}px 0px`});

            observer.observe(options.element);
        };

        class ScrollingPromotion extends HTMLElement {
            constructor() {
                super();

                this.config = {
                    moveTime: parseFloat(this.dataset.speed), // 100px going to move for
                    space: 100, // 100px
                };

                this.promotion = this.querySelector('.promotion');

                btheme.initWhenVisible({
                element: this,
                callback: this.init.bind(this),
                threshold: 600
                });
            }

            init() {
                if (this.childElementCount === 1) {
                this.promotion.classList.add('promotion--animated');

                for (let index = 0; index < 10; index++) {
                    this.clone = this.promotion.cloneNode(true);
                    this.clone.setAttribute('aria-hidden', true);
                    this.appendChild(this.clone);

                    const imageWrapper = this.clone.querySelector('.media-wrapper');
                    if (imageWrapper) {
                    imageWrapper.classList.remove('loading');
                    }
                }

                const animationTimeFrame = (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
                this.style.setProperty('--duration', `${animationTimeFrame}s`);

                // pause when out of view
                const observer = new IntersectionObserver((entries, _observer) => {
                    entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.scrollingPlay();
                    } else {
                        this.scrollingPause();
                    }
                    });
                }, {rootMargin: '0px 0px 50px 0px'});

                observer.observe(this);
                }
            }

            scrollingPlay() {
                this.classList.remove('scrolling-promotion--paused');
            }

            scrollingPause() {
                this.classList.add('scrolling-promotion--paused');
            }
        }
        customElements.define('scrolling-promotion', ScrollingPromotion);
    }
} catch (e) {
    console.error("Error123:: ", e);
}


(function() {
    function handleFocusMiniSearchBtns(event) {
      const target = event.target;
      if (target.classList.contains('t4s-mini-search__input')) {
        requestAnimationFrame(() => {
          target.focus();
          target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
      }
    }
  
    document.addEventListener('click', handleFocusMiniSearchBtns, false);
    document.addEventListener('touchend', handleFocusMiniSearchBtns, false);
})();

document.body.addEventListener('click', (e) => {
    const input = e.target.closest('[data-input-search]');
    if (input) {
      setTimeout(() => input.focus(), 50);
    }
});

document.body.addEventListener('touchend', (e) => {
    const input = e.target.closest('[data-input-search]');
    if (input) {
        setTimeout(() => input.focus(), 50);
    }
});

document.body.addEventListener('click', (e) => {
    const input = e.target.closest('[data-input-search]');
    if (!input) return;  
    
    input.focus();
    setTimeout(() => input.focus(), 50);
  });
